import { DataTableBodyCellDate } from '@/components/custom';
import DataTableBodyCellDetails from './DataTableBodyCellDetails';
import { TableBody, TableCell, TableRow } from '@/components/ui';
import type { IUserTransaction } from '@/interfaces';
import { TypeBadge } from './components/TypeBadge';
import { AmountDisplay } from './components/AmountDisplay';
import { getTitleEnumValue } from '@/functions';

type TProps = {
	transactions: IUserTransaction[];
};

export const DataTableBody = ({ transactions }: TProps) => (
	<TableBody>
		{[...transactions].map(item => (
			<TableRow key={item._id} className="h-12 hover:bg-muted/50 transition-colors">
				<DataTableBodyCellDate className="w-[110px] text-nowrap font-mono text-sm" date={item.createdAt} />
				<TableCell className="w-[100px] py-1">
					<TypeBadge type={item.type} />
				</TableCell>
				<TableCell className="w-[140px] font-medium text-sm py-1">{getTitleEnumValue('ProductsEnum', item.product)}</TableCell>
				<TableCell className="w-[120px] py-1 text-left">
					<AmountDisplay amount={item.amount} type={item.type} />
				</TableCell>
				<DataTableBodyCellDetails transaction={item} />
				<TableCell className="py-1 pe-0 text-muted-foreground text-sm max-w-[200px] truncate">
					<div className="truncate" title={item.options?.comment}>
						{item.options?.comment}
					</div>
				</TableCell>
			</TableRow>
		))}
	</TableBody>
);

export default DataTableBody;
